import * as _ from 'lodash';
import { environment } from './../../src/environments/environment';
class Constant {
    constructor() {
    }
    minDate = { year: 2018, month: 1, day: 1 };
    maxDate = { year: 2029, month: 12, day: 31 };
    dateFormat = 'DD-MM-YYYY HH:mm';
    DateFormatOnly = 'DD-MM-YYYY';
    receiptDateFormat = 'dd/MM/YYYY HH:mm';
    InternalError = 'Internal Error';

    localStorage = {
        prefix: 'engaje-',
        token: 'token',
        user_name: 'user_name',
        dp_url: 'dp_url',
        access: 'access',
        user_role_id: 'user_role_id',
        user_id: 'user_id',
        company_details_id: 'company_details_id',
        address: 'address',
        last_name: 'last_name',
        first_name: 'first_name',
        email: 'email',
        phone: 'phone',
        initial_payment: 'initial_payment',
        module_id: 'module_id',
        role_id: 'role_id',
        current_payment_status: 'current_payment_status',
        stripePayment: 'stripePayment',
        use_engaje_payment_account: 'use_engaje_payment_account',
        login_status: 'login_status',
        full_name: 'full_name',
        company_name: 'company_name',
        logo_url: 'logo_url',
        utc_offset: 'utc_offset'
    };
    DateFormatServerSideWithDateTime = "YYYY-MM-DD HH:mm";

    cryptoJs = {
        algorithm: 'aes-128-cbc',
        secretKey: 'adloggsangular&5&secret@mission'
    }
    DateFormatWithTimeHtml = 'DD-MM-YYYY HH:mm';
    DateFormatHtml = 'DD-MM-YYYY';
    timeFormatHtml = 'HH:mm'

    dateTimeFormat = 'DD-MM-YYYY HH:mm:ss';
    DateFormat = 'MM/DD/YYYY';

    DateFormatServerSideDate = "YYYY-MM-DD";
    stripeKey = environment.Service.stripeKey;
    RoleId = {
        master: 1,
        partner: 2,
        business: 3,
        staff: 4,
        community: 5
    }

    moduleId = {
        ekart: 12,
        foodKart: 13,
        cConnect: 2,
        skipques: 1,
        service: 14,
        tableOrdering: 15,
        job: 16
    }
    cartStatus = {
        incart: 'In Cart',
        inkitchan: 'In Kitchen',
        cooked: 'Cooked',
        served: 'Served',
        cancelled: 'Cancelled',
    }

    DeliveryType = {
        14: {
            "Click and Collect": "Drop in",
            "Delivery": "Call out service"
        },
        13: {
            "Click and Collect": "Takeaway",
            "Delivery": "Delivery"
        },
        15: {
            "Click and Collect": "Takeaway",
            "Delivery": "Delivery"
        },
        12: {
            "Click and Collect": "Takeaway",
            "Delivery": "Delivery"
        }
    }

    orderStatusName = {
        1: "Pending",
        2: "Received",
        3: "Processing",
        4: "Unserviceable",
        5: "Ready",
        6: "Completed",
        7: "Assigned"
    }
    orderStatusId = {
        "Pending": 1,
        "Received": 2,
        "Processing": 3,
        "Unserviceable": 4,
        "Ready": 5,
        "Completed": 6,
        "Assigned": 7
    }
    JobStatus = {
        pending: "Pending",
        contacted: "Contacted",
        accepted: "Accepted",
        rejected: "Rejected",
    };
    queueStatus = [{ name: 'Waiting' }, { name: 'Seated' }, { name: 'Cancel' }]

    actionList = ["Pending", "Contacted", "Accepted", "Rejected"];

    tagTypeList = [{ id: 1, name: "Veg" }, { id: 2, name: "Non-veg" },
        //  { id: 3, name: "Egg" }, { id: 4, name: "None" }
    ];
    tagTasteList = [{ id: 1, name: "Mild" }, { id: 2, name: "Hot" }, { id: 3, name: "Very hot" }, { id: 4, name: "None" }];
    tagSpeicalList = [{ id: 1, name: "Chef Special" }, { id: 2, name: "Signature Dish" }, { id: 3, name: "Best Seller" }, { id: 4, name: "Must Try" }, { id: 4, name: "None" }];
    tagTasteListFilter = [{ id: 1, name: "Mild" }, { id: 2, name: "Hot" }, { id: 3, name: "Very hot" }];
    tagSpeicalListFilter = [{ id: 1, name: "Chef Special" }, { id: 2, name: "Signature Dish" }, { id: 3, name: "Best Seller" }, { id: 4, name: "Must Try" }];
    deliveryType = [{ id: 1, name: "Delivery" }, { id: 2, name: "Click and Collect" }];
    deliveryPartnerList = [{ id: 1, name: "DoorDash" }]
    Client = {
        Auth: {
            BaseUrl: environment.Service.AuthBaseUrl,
        },
        DeviceLink: {
            link: environment.Service.deviceUrl
        }
    }
    // logoUrl = environment.Service.logoUrl;
    // logoIcon = environment.Service.logoIcon;
    ImageUrl = {
        BaseUrl: environment.Service.ImageBaseUrl,
        Engaje: {
            File: {
                Create: "file"
            },
            Create: 'create',
            LoginShowImage: 'https://images.engaje.app/',
            ShowImage: 'image?url=',
            serverImage: 'https://phoenix.ams3.digitaloceanspaces.com/'
        }
    }

    errOrFalseRes = {
        data: [],
        pagination: {
            totalRows: 0,
            rowSize: 10,
            currentPage: 1
        }
    }
    IsoCodeForCountry = {
        "+91": "in",
        "+94": "lk",
        "+44": "uk",
        "+61": "au",
        "+1": "us"
    }

    Service = {
        MainMaster: {
            AuthBaseUrl: environment.Service.AuthBaseUrl,
            BaseUrl: environment.Service.EngajeLoginApiBaseUrl,
            BusinessBaseUrl: environment.Service.EngajeBusinessApiBaseUrl,
            QueueUser: {
                BaseValue: environment.Service.queueUserId
            },
            Auth: {
                // Logout: 'user/session/logout'
            },
            Dashboard: {
                foutBox: 'dashboard/fourbox',
            },
            User: {
                Login: 'user/login',
                LogOut: 'user/logout',
                GetUser: 'user/getuser',
                Create: 'user/signup',
                Createpwd: 'user/createpwd',
                // Companydtlcreate: 'cmpdtl/create',
                // Companydtlupdate: 'cmpdtl/update'
                UserEmailLogin: 'user/buslist',
                Userupdate: 'user/update',
                Usercreate: 'user/create',
                socialLinkCreate: 'usersocialdetail/create',
                socialLinkDelete: 'usersocialdetail/delete',
                resetEmailCode: 'user/pwresetcode',
                resetPassword: 'user/resetpw'
            },
            receipt: {
                receiptApi: 'order/getbyuuid/'
            },
            Payment: {
                CalculatePrice: 'payment/pricecalc',
                Bussinesspayment: 'payment/module',
                Paymenturl: 'store/oauth/stripe/acc',
                StoreIntegration: 'store/stripeaccountinteg',
                GetAll: 'payment/txn'
            },
            Staff: {
                GetAll: 'cc/ccstaff/getall',
                Create: 'cc/ccstaff/create',
                Update: 'cc/ccstaff/update',
                GetOne: 'cc/ccstaff/getbyid'
            },
            Order: {
                GetAll: 'order/getall',
                GetById: 'order/getbyid',
                ChangeQuantity: 'order/chgquantity',
                CancelCart: 'order/cancelcart',
                OrderUpdate: 'order/update',
                OrderCount: 'order/ordercount',
                OrderUpdateWithOutToken: 'order/updatebyuuid',
                DpCancel: 'order/canceltodp'
            },
            Dynamic: {
                Dynamicapi: 'dynamic'
            },
            module: {
                userModules: 'module/getallsubmodule',
                AvailableModule: 'module/getallavailablemodule',
                userValidationModule: 'module/usermodule/getone'
            },
            Location: {
                LocationGetall: 'location/getall',
                Update: 'location/update'
            },
            Customer: {
                CustomerList: 'customer/getall',
                Visit: {
                    Getall: 'customer/visit/getall'
                },
                UpdateQueueStatus: 'customer/updateQueue',
                QueueNotification: 'customer/queuenotify'
            },
            TableOrdering: {
                Create: 'table/create',
                GetAll: 'table/getall',
                GetBYId: 'table/getbyid',
                Update: 'table/update',
                CustomerwiseOrderList: 'table/livelist',
                AddtocartWiewOrEdit: 'addtocart/getallforbus',
                StatusUpdate: 'addtocart/statusmulupdate'
            },
            Jobs: {
                Job: {
                    Create: 'communityevent/create',
                    GetAll: 'communityevent/getAll',
                    Update: 'communityevent/update',
                },
                Tag: {
                    create: 'communitygroup/create',
                    GetAll: 'communitygroup/getAll',
                    Update: 'communitygroup/update',
                },
                InterestJobs: {
                    GetAll: 'communityeventbooking/getAll',
                    Update: 'communityeventbooking/update',
                },
            },
            DeliveryPartner: {
                GetAllAvailablePartner: 'deliverypartner/getallavldp',
                CreateDp: 'deliverypartner/createdp',
                GetAll: 'deliverypartner/getalldp',
                update: 'deliverypartner/updatedp'
            },
            Product: {
                GetAll: 'product/getall',
                Create: 'product/create',
                GetById: 'product/getbyid',
                Update: 'product/update',
                import: 'product/imp',
                Category: {
                    createCategory: 'category/create',
                    CategoryGetAll: 'category/getall',
                    CategoryUpdate: 'category/update',
                },
                SubCategory: {
                    SubCategoryGetAll: 'subcategory/getall',
                    SubCategoryCreate: 'subcategory/create',
                    SubCategoryUpdate: 'subcategory/update',
                },
                ProductSpec: {
                    GetAll: 'productspec/getall',
                    Update: 'productspec/update',
                    Create: 'productspec/create'
                },
                ManuFacture: {
                    ManuFactureGetAll: 'manufacturer/getall',
                    ManuFactureCreate: 'manufacturer/create',
                    ManuFactureUpdate: 'manufacturer/update',
                },
                Unit: {
                    UnitGetAll: 'unit/getall',
                },
                IndustryType: {
                    GetAll: 'userindustrysubcategory/get',
                    Create: 'userindustrysubcategory/create',
                    Delete: 'userindustrysubcategory/delete',
                },
                Promotion: {
                    GetAll: 'promotion/getallpromo',
                    Create: 'promotion/create',
                    Update: 'promotion/update',
                },
                Community: {
                    CommunityList: 'community/memcommlist',
                    JoinCommunity: 'community/joinmembers',
                    UnjoinCommunity: 'community/unjoinmembers',
                },
            },
            Report: {
                orderReport: 'orderreport/list'
            }
        }

    }
}


let constant = new Constant();
export default constant;